<template>
    <q-select
        v-bind="$attrs"
        :outlined="outlined"
        :dense="dense"
        :filled="filled"
        :clearable="clearable"
        :options="options"
        @input="$emit('input', $event)"
        map-options
        :data-component-name="$options.name"
    >
    <!-- <q-select
        v-bind="$attrs"
        :outlined="outlined"
        :dense="dense"
        :filled="filled"
        :clearable="clearable"
        :options="options"
        @input="$emit('input', $event)"
        map-options
        :use-input="$attrs.options.length>60"
        @filter="filterFn"
    > -->
        
    </q-select>
</template>
<script>
import QSelect from 'quasar'
export default {
    name: 'Select',
    extends: QSelect,
    props: {
        outlined: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: true
        },
        filled: {
            type: Boolean,
            default: true
        },
        clearable: {
            type: Boolean,
            default: true
        }
    },
    data(){
        return{
            // options: []
        }
    },
    mounted(){
        // this.options=this.$attrs.options;
    },
    computed: {
        options(){
            return this.$attrs.options;
        }
    },
    methods: {
        // filterFn (val, update, abort) {
        //     update(() => {
        //         const needle = val.toLowerCase()
        //         this.options = this.$attrs.options.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
        //     })
        // }
    }
}
</script>
